class Text {
  static getApproveStatusText(asId) {
    var _text = "";
    switch (asId) {
      case 0:
        _text = "新添加";
        break;
      case 1:
        _text = "审核通过";
        break;
      case 2:
        _text = "审核驳回";
        break;
      case 3:
        _text = "已编辑";
        break;
    }
    return _text;
  }

  static getApproveStatusApplyText(asId) {
    var _text = "";
    switch (asId) {
      case 0:
        _text = "待审核";
        break;
      case 1:
        _text = "已完成";
        break;
      case 2:
        _text = "已失败";
        break;
    }
    return _text;
  }

  static getTransactionStatusText(id) {
    var _text = "";
    switch (id) {
      case 0:
        _text = "待处理";
        break;
      case 1:
        _text = "已处理";
        break;
      case 2:
        _text = "已失效";
        break;
    }
    return _text;
  }
}

export default Text;



// WEBPACK FOOTER //
// ./src/tools/text.js